import React from 'react';

import './Breadcrumbs.scss';
import { econdaClickEvent } from '../../Econda';
import { useTranslation } from '../../hooks/useTranslation';
import { RequestHandler } from '../../app/RequestHandler';
import useFoXHeadline from '../Headline/useFoxHeadline';

enum TranslationKeys {
  HOME = 'home',
  ENGINEERING_TOOLS = 'engineeringTools',
  MEDIA_RESISTANCE_TOOL = 'headline',
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function Breadcrumbs() {
  const t = useTranslation();
  const { hasFoXBreadcrumbs } = useFoXHeadline();
  const { country, language } = new RequestHandler();

  const homeUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/`;
  const engineeringToolsUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/e/products/digital-engineering-tools-id_650881/`;

  function onBreadcrumbsHomeClick(e: React.MouseEvent) {
    econdaClickEvent('media resistance', 'general', 'breadcrumbs', 'home');
  }

  function onBreadcrumbsEngineeringToolsClick(e: React.MouseEvent) {
    econdaClickEvent('media resistance', 'general', 'breadcrumbs', 'engineering tools');
  }

  if (hasFoXBreadcrumbs) return <></>;

  return (
    <>
      <div className="fwe-breadcrumbs-container fwe-d-flex mb-0">
        <a
          target="_blank"
          rel="noreferrer"
          className="breadcrumbs-link"
          onClick={onBreadcrumbsHomeClick}
          href={homeUrl}
        >
          {t(TranslationKeys.HOME)}
        </a>
        <i className={`fwe-icon fwe-icon-arrows-right-2`} />
        <a
          target="_blank"
          rel="noreferrer"
          className="breadcrumbs-link"
          onClick={onBreadcrumbsEngineeringToolsClick}
          href={engineeringToolsUrl}
        >
          {t(TranslationKeys.ENGINEERING_TOOLS)}
        </a>
        <i className={`fwe-icon fwe-icon-arrows-right-2`} />
        <span>{t(TranslationKeys.MEDIA_RESISTANCE_TOOL)}</span>
      </div>
      <div className="show-only-on-375 container-fluid">
        <i className="fwe-icon fwe-icon-arrows-left-2"></i>
        <a
          target="_blank"
          rel="noreferrer"
          className="tool-link"
          onClick={onBreadcrumbsEngineeringToolsClick}
          href={engineeringToolsUrl}
        >
          {t(TranslationKeys.ENGINEERING_TOOLS)}
        </a>
      </div>
    </>
  );
}

export default Breadcrumbs;
